import { axiosAjax } from './common'
const assistUrl = 'http://120.27.135.41:9527/api'

export default {
	// load workgroup resource
	getWorkGroupResource(params) {
		// return axiosAjax('/project_resource', 'GET', {params: params})
		return axiosAjax(`/v1/project/resources/${params.id}`, 'GET', { params: params.params })
	},
	// get favourite work group
	getFavouriteWorkGroup(params) {
		return axiosAjax('/project/favourite', 'GET', { params: params })
	},
	// load work group list
	getWorkGroupList(params) {
		return axiosAjax('/v1/project/list', 'GET', { params: params })
	},
	// set work group favourite
	setFavourite(params) {
		return axiosAjax(`/project/${params.id}/favourite`, 'PUT', { data: params })
	},
	// get detail for work group
	getWorkGroupDetail(params) {
		return axiosAjax(`/v1/project/${params.id}`, 'GET')
	},
	getTunnelCode(params) {
		return axiosAjax('/tunnel', 'GET', { params: params })
	},
	// 获取报告版本类型
	getVersionByType(params) {
		return axiosAjax(`/report/get_version_by_type`, 'GET', { params })
	},
	// 发起诊断报告
	createCsosReport(data) {
		return axiosAjax('/report/create_csos_report', 'post', { data })
	},
	// 获取诊断报告列表
	getCsosReport(params) {
		return axiosAjax(`/report/get_csos_report`, 'GET', { params })
	},
	// 查询月报更新状态
	getCsosReportState(params) {
		return axiosAjax(`/report/task_status`, 'GET', { params })
	},
	// 删除工作组资源
	delWorkGroupResource(id) {
		return axiosAjax('/v1/project/' + id, 'delete')
	},
	// 创建工作组
	createdWorkGroupResource(params) {
		return axiosAjax('/v1/project', 'post', { data: params })
	},
	// 修改工作组
	patchWorkGroupResource(params) {
		return axiosAjax('/v1/project/' + params.id, 'patch', { data: params.data })
	},
	getConnectLog(params) {
		return axiosAjax('/search_tunnel', 'get', { params: params })
	},
	getTunnelInfo(data) {
		return axiosAjax('/tunnel', 'post', { data: data })
	},
	// 测试主机账号密码连接
	testPasswordConnection(data) {
		return axiosAjax('/tunnel/test_password_connection', 'post', { data: data })
	},
	updateTunnel(code, data) {
		return axiosAjax('/tunnel/' + code, 'patch', { data: data })
	},
	// 添加工作组资源
	addWorkgroupResource(params) {
		// return axiosAjax('/batch/project_resource', 'post', {data: params})
		return axiosAjax('/v1/project/resources/' + params.projectId, 'post', { data: params.data })
	},
	// 删除多个工作组资源
	batchDelWorkgroupResource(params) {
		// return axiosAjax('/batch/project_resource/' + ids, 'delete')
		return axiosAjax('/v1/project/resources/' + params.projectId, 'delete', { data: params.data })
	},
	// 删除成员
	delWorkGroupMember(params) {
		return axiosAjax(`/project/${params.projectId}/member`, 'delete', { params: params.data })
	},
	// 添加成员
	addWorkgroupMember(params) {
		return axiosAjax(`/project/${params.projectId}/member`, 'post', { data: params.data })
	},
	// 获取成员列表
	getWorkgroupMemberList(params) {
		return axiosAjax(`/v1/project/members/${params.id}`, 'GET', { params: params.data })
	},
	// 获取群组列表
	getWorkgroupGroup(params) {
		return axiosAjax(`/project/${params.projectId}/group`, 'GET', { params: params.data })
	},
	// 获取群组列表
	getWorkgroupGroupList(params) {
		return axiosAjax(`/v1/project/groups/${params.id}`, 'GET', { params: params.data })
	},
	// 删除群组
	delWorkgroupGroup(params) {
		return axiosAjax(`/project/${params.projectId}/group`, 'delete', { params: params.data })
	},
	// 添加群组
	addWorkgroupGroup(params) {
		return axiosAjax(`/project/${params.projectId}/group`, 'post', { data: params.data })
	},
	// 修改成员权限
	patchWorkGroupMember(params) {
		return axiosAjax(`/project/${params.projectId}/member`, 'patch', { data: params.data })
	},
	// 获取工作组成员管理员
	getWorkgroupMemberAdmin(projectId) {
		return axiosAjax(`/project/${projectId}/admin`)
	},
	getPeojectResourceInfo(id) {
		return axiosAjax('/project_resource/' + id, 'get')
	},
	changeLoginUser(params) {
		return axiosAjax(`/project_resource/${params.id}/login_username`, 'post', { data: params.data })
	},
	getClientIp() {
		return axiosAjax('/client_ip', 'get')
	},
	createCode(data) {
		return axiosAjax('/tunnel', 'post', { data: data })
	},
	deleteCode(code, data) {
		return axiosAjax('/tunnel/' + code, 'patch', { data: data })
	},
	getCodeInfo(code) {
		return axiosAjax('/tunnel/' + code, 'get')
	},
	modifyCode(code, data) {
		return axiosAjax('/tunnel/' + code, 'patch', { data: data })
	},
	setProjectDafaultName(id, data) {
		return axiosAjax('/project_resource/' + id + '/default_username', 'put', { data: data })
	},
	getCodeVersion(params) {
		return axiosAjax('/tunnel', 'get', { params: params })
	},
	// 获取工作组资源在线连接列表
	getResourceOnlineConnects(params) {
		return axiosAjax('/v1/tunnel_connection/list', 'get', { params: params })
	},
	// lite 连接详情
	getLiteConnectInfo(params) {
		return axiosAjax('/v1/tunnel', 'post', { baseURL: assistUrl, data: params })
	},
	// 获取协助信息
	getAssistInfo(params) {
		return axiosAjax('/v1/tunnel/connections', 'get', { baseURL: assistUrl, params: params })
	},
	// 获取协助主链接上的shadow连接
	getShadowConnect(params) {
		return axiosAjax('/v1/tunnel/shadow', 'post', { baseURL: assistUrl, data: params })
	},
	queryCsosConnect(params) {
		return axiosAjax('/tunnel/connections', 'get', { params: params })
	},
	getCsosShadow(params) {
		return axiosAjax('/tunnel/shadow/code', 'post', { data: params })
	},
	// SQL语法校验
	verifySQL(params) {
		return axiosAjax('/sql_application/verify', 'post', { data: params })
	},
	// 获取工作组成员下的工作组列表
	getAccountWorkgroupList(params) {
		return axiosAjax('/v1/project/get_project_by_account/' + params.id, 'get', params)
	},

	// 添加成员下工作组
	addAccountWorkgroup(params) {
		return axiosAjax('/project/bulk_add_project', 'post', { data: params })
	},
	// 删除成员下工作组
	deleteAccountWorkgroup(params) {
		return axiosAjax('/project/bulk_delete_project', 'delete', { data: params })
	},

	// 获取群组下的工作组列表
	getWorkGroupListByGroup(params) {
		return axiosAjax(`/group/${params.id}/project`, 'GET')
	},
	// 添加群组下工作组
	addGroupWorkgroup(params) {
		return axiosAjax(`/group/${params.id}/project`, 'post', { data: params })
	},
	// 删除群组下工作组
	deleteGroupWorkgroup(params) {
		return axiosAjax(`/group/${params.id}/project`, 'delete', { data: params })
	},
}



// WEBPACK FOOTER //
// ./src/api/workgroup.js